var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconContainer = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#ECEEF1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8536 5.14645C11.0488 5.34171 11.0488 5.65829 10.8536 5.85355L5.85355 10.8536C5.65829 11.0488 5.34171 11.0488 5.14645 10.8536C4.95118 10.6583 4.95118 10.3417 5.14645 10.1464L10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645Z",
  fill: "#394455"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645L10.8536 10.1464C11.0488 10.3417 11.0488 10.6583 10.8536 10.8536C10.6583 11.0488 10.3417 11.0488 10.1464 10.8536L5.14645 5.85355C4.95118 5.65829 4.95118 5.34171 5.14645 5.14645Z",
  fill: "#394455"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconContainer, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNFQ0VFRjEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC44NTM2IDUuMTQ2NDVDMTEuMDQ4OCA1LjM0MTcxIDExLjA0ODggNS42NTgyOSAxMC44NTM2IDUuODUzNTVMNS44NTM1NSAxMC44NTM2QzUuNjU4MjkgMTEuMDQ4OCA1LjM0MTcxIDExLjA0ODggNS4xNDY0NSAxMC44NTM2QzQuOTUxMTggMTAuNjU4MyA0Ljk1MTE4IDEwLjM0MTcgNS4xNDY0NSAxMC4xNDY0TDEwLjE0NjQgNS4xNDY0NUMxMC4zNDE3IDQuOTUxMTggMTAuNjU4MyA0Ljk1MTE4IDEwLjg1MzYgNS4xNDY0NVoiIGZpbGw9IiMzOTQ0NTUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE0NjQ1IDUuMTQ2NDVDNS4zNDE3MSA0Ljk1MTE4IDUuNjU4MjkgNC45NTExOCA1Ljg1MzU1IDUuMTQ2NDVMMTAuODUzNiAxMC4xNDY0QzExLjA0ODggMTAuMzQxNyAxMS4wNDg4IDEwLjY1ODMgMTAuODUzNiAxMC44NTM2QzEwLjY1ODMgMTEuMDQ4OCAxMC4zNDE3IDExLjA0ODggMTAuMTQ2NCAxMC44NTM2TDUuMTQ2NDUgNS44NTM1NUM0Ljk1MTE4IDUuNjU4MjkgNC45NTExOCA1LjM0MTcxIDUuMTQ2NDUgNS4xNDY0NVoiIGZpbGw9IiMzOTQ0NTUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };